export enum LoadingResult {
  Success = "success",
  Failure = "failure"
}
